export const CATEGORIAS_EGRESO = [
    { value: 'renta_arrendamiento', label: 'Renta y arrendamiento' },
    { value: 'servicios_profesionales', label: 'Servicios profesionales' },
    { value: 'publicidad_marketing', label: 'Publicidad y marketing' },
    { value: 'tecnologia_software', label: 'Tecnología y software' },
    { value: 'transporte_viaticos', label: 'Transporte y viáticos' },
    { value: 'equipo_herramientas', label: 'Equipo y herramientas' },
    { value: 'nomina_honorarios', label: 'Nómina y honorarios' },
    { value: 'otros_deducibles', label: 'Otros gastos deducibles' },
    { value: 'no_deducible', label: 'Gastos no deducibles' }
]

export const STATUS_OPTIONS = [
    { value: '', label: 'Todos' },
    { value: 'pendiente_comprobante', label: 'Pendiente comprobante' },
    { value: 'pendiente_pago', label: 'Pendiente pago' },
    { value: 'pagada', label: 'Pagadas' },
    { value: 'cancelada', label: 'Canceladas' }
]

export const statusLabels = {
    pendiente_comprobante: 'Sin comprobante',
    pendiente_pago: 'Por pagar',
    pagada: 'Pagada',
    cancelada: 'Cancelada'
}

export const isDeducibleByUsoCFDI = (usoCFDI) => [
    'G01', 'G02', 'G03',
    'I01', 'I02', 'I03', 'I04', 'I05', 'I06', 'I07', 'I08',
    'D01', 'D02', 'D03', 'D04', 'D05', 'D06', 'D07', 'D08', 'D09', 'D10'
].includes((usoCFDI || '').toUpperCase())

export const suggestCategoria = (usoCFDI) => {
    const uso = (usoCFDI || '').toUpperCase()
    if (uso === 'G01' || uso === 'G03') return 'otros_deducibles'
    if (/^I0[1-8]$/.test(uso)) return 'equipo_herramientas'
    if (['D01', 'D05', 'D07'].includes(uso)) return 'servicios_profesionales'
    if (['S01', 'CP01'].includes(uso)) return 'no_deducible'
    return 'otros_deducibles'
}

export const getCategoriaLabel = (value) => CATEGORIAS_EGRESO.find(c => c.value === value)?.label || value

export const toDateInput = (value) => {
    if (!value) return ''
    const date = new Date(value)
    if (Number.isNaN(date.getTime())) return ''
    return date.toISOString().slice(0, 10)
}

const getAttr = (doc, tagName, attrName) => {
    const node = doc.getElementsByTagName(tagName)[0]
    return node?.getAttribute(attrName) || ''
}

const getFirstNodeByLocalName = (doc, localName) => {
    return Array.from(doc.getElementsByTagName('*')).find(node => node.localName === localName)
}

const getAttrByLocalName = (doc, localName, attrName) => {
    const node = getFirstNodeByLocalName(doc, localName)
    return node?.getAttribute(attrName) || ''
}

export const parseEgresoXmlPreview = async (file) => {
    const xml = await file.text()
    const doc = new DOMParser().parseFromString(xml, 'text/xml')
    const parserError = doc.getElementsByTagName('parsererror')[0]
    if (parserError) {
        throw new Error('No pude leer el XML seleccionado.')
    }

    const usoCFDI = getAttrByLocalName(doc, 'Receptor', 'UsoCFDI')
    const fechaTimbrado = getAttrByLocalName(doc, 'TimbreFiscalDigital', 'FechaTimbrado')
    const fecha = getAttr(doc, 'cfdi:Comprobante', 'Fecha') || getAttrByLocalName(doc, 'Comprobante', 'Fecha')
    const descripcion = Array.from(doc.getElementsByTagName('*'))
        .filter(node => node.localName === 'Concepto')
        .map(node => node.getAttribute('Descripcion'))
        .filter(Boolean)
        .join(', ')

    return {
        emisorRfc: getAttrByLocalName(doc, 'Emisor', 'Rfc'),
        emisorNombre: getAttrByLocalName(doc, 'Emisor', 'Nombre'),
        total: getAttr(doc, 'cfdi:Comprobante', 'Total') || getAttrByLocalName(doc, 'Comprobante', 'Total'),
        fechaGasto: toDateInput(fechaTimbrado || fecha),
        usoCFDI,
        moneda: getAttr(doc, 'cfdi:Comprobante', 'Moneda') || getAttrByLocalName(doc, 'Comprobante', 'Moneda') || 'MXN',
        tipoCambio: getAttr(doc, 'cfdi:Comprobante', 'TipoCambio') || getAttrByLocalName(doc, 'Comprobante', 'TipoCambio') || '1',
        categoria: suggestCategoria(usoCFDI),
        deducible: isDeducibleByUsoCFDI(usoCFDI),
        descripcion
    }
}

export const getInitialEgresoForm = (egreso = null) => ({
    fechaGasto: toDateInput(egreso?.fechaGasto) || toDateInput(new Date()),
    emisorRfc: egreso?.emisor?.rfc || '',
    emisorNombre: egreso?.emisor?.nombre || '',
    total: egreso?.total || '',
    moneda: egreso?.moneda || 'MXN',
    tipoCambio: egreso?.tipoCambio || 1,
    categoria: egreso?.categoria || 'otros_deducibles',
    descripcion: egreso?.descripcion || '',
    deducible: egreso ? egreso.deducible === true : true
})

export const buildEgresoFormData = ({ form, xmlFile }) => {
    const formData = new FormData()
    if (xmlFile) formData.append('xml', xmlFile)
    Object.entries(form).forEach(([key, value]) => {
        formData.append(key, value)
    })
    return formData
}
